{
  "groups": {
    "referenceNumber": "Número de referencia",
    "appointmentStartTimes": "Horarios de inicio de citas",
    "appointmentNotifications": "Notificaciones de citas",
    "appointmentStatuses": "Estados de citas",
    "customAppointmentsGrid": "Cuadrícula de citas personalizada",
    "limiter": "Limitador",
    "schedulingPortal": "Portal de programación",
    "dockSelection": "Selección de muelle",
    "timeDisplay": "Visualización de la hora",
    "gateManagement": "Gestión de accesos",
    "smartGate": "SmartGate",
    "idValidation": "Validación de ID",
    "appointmentValidation": "Validación de citas",
    "other": "Otro",
    "handlingUnits": "Unidades de Manejo"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "El número de referencia es el que puedes solicitar a los transportistas cuando estén programando una cita.",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "Determina los intervalos de tiempo en los que se permitirán iniciar las citas.",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "Administra todos los tipos de notificaciones de citas para esta {entity}.",
    "manageTheSchedulingPortalSettingsForThisEntity": "Administra la configuración del portal de programación para esta {entity}.",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "Unidades de Manejo es un campo numérico para solicitar unidades (ej. pallets) durante la programación de citas. Agrégalo a tu formulario para también habilitar la función de Limitador.",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "El Limitador te permite establecer un número máximo de citas o unidades de manejo (ej. pallets) que se pueden programar por día."
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "Cantidad mínima de números de referencia",
    "maximumAmountOfReferenceNumbers": "Cantidad máxima de números de referencia",
    "includeReferenceNumberFieldOnAllAppointmentForms": "¿Incluir el campo de número de referencia en todos los formularios de citas?",
    "referenceNumberFieldName": "Nombre del campo de número de referencia",
    "referenceNumberHelperText": "Texto de ayuda del número de referencia",
    "makeReferenceNumberARequiredField": "¿Hacer que el número de referencia sea un campo obligatorio?",
    "allowAppointmentsForThisEntityToStartAt": "Permitir que las citas para esta {entity} comiencen a las:",
    "enableAppointmentNotificationsForThisEntity": "¿Habilitar notificaciones de citas para esta {entity}?",
    "selectEachDesiredStartTimeIndividually": "Selecciona cada hora de inicio deseada individualmente",
    "hideTheLoadTypeDuration": "¿Ocultar la duración del tipo de carga?",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "Sube el logotipo de tu {entity} para mostrarlo en el portal de programación y en todas las notificaciones por correo electrónico",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "Sube el mapa del patio del almacén para mostrarlo en el portal de programación",
    "statusForNewlyCreatedAppointments": "Estado para las citas recién creadas",
    "muteAppointmentNotifications": "Silenciar notificaciones de citas",
    "allowDockSelectionInSchedulingPortal": "¿Permitir la selección de muelle en el portal de programación?",
    "theStatusThatFollowsArrivedIs": "El estado que sigue a 'Llegado' es",
    "displayTimeIn": "Mostrar hora en:",
    "customizeAppointmentDetails": "Personalizar detalles de la cita",
    "gridTileConfig": "Configuración de mosaicos de la cuadrícula",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "Aplicar geocercas para requerir que los conductores proporcionen su ubicación en tiempo real",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "¿Deseas mostrar información adicional a los conductores después de que se registren? (opcional)",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "¿Prevenir la reprogramación de citas en el portal de programación?",
    "revertToRequestedOnCarrierReschedule": "Revertir a Solicitado al reprogramar por el transportista",
    "observationMatchAttribute": "Atributo de coincidencia de observación",
    "observationMatchTimeWindow": "Ventana de tiempo de coincidencia de observación",
    "autoDepartAssets": "Realizar salidas automáticas de activos",
    "autoCreateAssets": "Crear activos automáticamente",
    "gateFeedColumns": "Columnas del Gate Feed",
    "checkInEarlyThreshold": "Umbral de entrada anticipada",
    "checkInLateThreshold": "Umbral de entrada tardía",
    "technicalContactEmailAddress": "Correo electrónico de contacto técnico",
    "technicalContactEmailThrottleMinutes": "Minutos de límite para correo electrónico técnico",
    "requireUniqueReferenceNumbers": "Requerir números de referencia únicos",
    "appointmentStartTimeInterval": "Intervalo de hora de inicio de cita",
    "referenceNumberInputMode": "Modo de ingreso de número de referencia",
    "uploadWarehouseYardMap": "Sube el mapa del patio del almacén para mostrarlo en el portal de programación",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "¿Incluir el campo de Unidades de Manejo en todos los formularios de citas?",
    "handlingUnitsLabel": "Etiqueta de Unidades de Manejo",
    "handlingUnitsHelperText": "Texto de ayuda de Unidades de Manejo",
    "makeHandlingUnitsARequiredField": "¿Hacer que las Unidades de Manejo sean un campo obligatorio?",
    "maximumHandlingUnitsValueForAnAppointment": "Valor máximo de Unidades de Manejo para una cita",
    "minimumHandlingUnitsValueForAnAppointment": "Valor mínimo de Unidades de Manejo para una cita",
    "checkOutBolSignedRequired": "Requiere firma de BOL en la salida",
    "requireBolPrinting": "Requerir impresión del BOL",
    "checkOutBolNotLoadingErrorMessage": "Mensaje de error cuando el BOL no carga en la salida",
    "checkOutIdentifier": "Identificador de salida",
    "enableCheckInIdValidationPersona": "Habilitar validación de ID en el check-in (Persona)",
    "requireCheckInIdValidationToCompleteCheckIn": "Requerir validación de ID para completar el check-in",
    "checkInIdValidationTemplate": "Plantilla de validación de ID en el check-in",
    "geofenceRadius": "Radio de geocerca",
    "geofenceRadiusUnit": "Unidad del radio de la geocerca",
    "createAppointmentOnExternalValidationFailure": "Crear cita ante fallo de validación externa",
    "enableOverrideLimiterFunction": "Habilitar función de anulación del limitador",
    "receiveUnplannedCheckInEmailNotifications": "Recibir notificaciones por correo de check-in no planificado",
    "driversMustEnterAReferenceNumberToCheckIn": "Los conductores deben ingresar un número de referencia para el check-in",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "Los conductores solo pueden hacer check-in si el número de referencia coincide con la cita programada",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "Los conductores omiten el paso del número de referencia durante el check-in",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "Personaliza el primer mensaje SMS que reciben los conductores después del check-in (opcional)",
    "includeYardMapImageInTheFirstCheckInSms": "¿Incluir la imagen del Mapa del Patio en el primer SMS de check-in?",
    "automaticallyDeleteStoredIdValidations": "Eliminar automáticamente las validaciones de ID almacenadas",
    "deleteStoredIdValidationsAfter": "Eliminar las validaciones de ID almacenadas después de",
    "displayDatesAs": "Mostrar fechas como:",
    "displayTimeAs": "Mostrar la hora como:"
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "Requiere al menos esta cantidad de números de referencia para una cita",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "Requiere como máximo esta cantidad de números de referencia para una cita",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "El nombre visible para el campo de número de referencia. Ej: \"Número de orden de compra\", \"ID de envío\"",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "Información adicional para ayudar a completar el campo del número de referencia. Ej: \"El número de referencia debe comenzar con OD-XX\"",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "Requiere el número de referencia para todas las citas programadas",
    "thisOnlyAffectsNewlyCreatedAppointments": "Esto solo afecta a las citas recién creadas",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "La duración se muestra en la lista de tipos de carga al programar una cita en el portal de programación",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "Permitir la selección de muelle al programar una cita en el portal de programación",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "Esta configuración permitirá la elección de un estado alternativo 'En progreso' entre 'Llegado' y 'Completado'",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "Determina cómo se mostrará el tiempo en toda la plataforma para todos los usuarios de esta organización, incluyendo la cuadrícula de citas e informes",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "Habilita el nuevo sistema personalizable de detalles de citas",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "Configuración del usuario sobre cómo se mostrarán los mosaicos de la cuadrícula",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "Esta configuración solicita la ubicación del conductor y les restringe registrarse si están a más de una milla de su almacén",
    "preventCarriersFromReschedulingAppointmentsOptional": "Evita que los transportistas reprogramen citas. (opcional)",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "Cuando un transportista reprograme una cita Programada, regresarla a Solicitado para una nueva aprobación",
    "attributeToBeUsedForMatchingObservations": "Atributo que se utilizará para emparejar observaciones",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "El número de minutos que se consideran antes y después de la hora de entrada para una observación",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "El número de minutos antes de la hora de inicio de la cita en que un transportista puede registrarse",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "El número de minutos después de la hora de inicio de la cita en que un transportista puede registrarse",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "Dirección de correo electrónico donde se enviarán los problemas técnicos e información",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "El tiempo entre notificaciones enviadas al contacto técnico cuando ocurre un error del servidor de validación",
    "aListOfMutedAppointmentNotifications": "Una lista de notificaciones de citas silenciadas",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "Requiere números de referencia únicos para todas las citas programadas",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "Este es el intervalo (en minutos) entre las horas posibles de inicio de citas",
    "enableTheCustomAppointmentStartTimesSetting": "Habilita la configuración de horarios personalizados de inicio de citas",
    "theInputModeForTheReferenceNumberField": "El modo de ingreso para el campo del número de referencia",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "El nombre visible para el campo de tipo de unidad. Ej: Conteo de pallets, Conteo de skids",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "Requiere el campo de tipo de unidad para todas las citas programadas",
    "autoDepartAssetsOnReceivingOutgateEvent": "Salida automática de activos al recibir evento de salida",
    "autoCreateAssetsOnReceivingIngateEvent": "Creación automática de activos al recibir evento de entrada",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "Columnas disponibles en la página AI Gate Feed. Las columnas obligatorias siempre se muestran.",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "Crear citas aunque la validación de la cita no sea exitosa",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "El radio en millas dentro del cual el conductor debe estar para poder registrarse. Esto solo aplica si la geocerca está habilitada.",
    "theDistanceUnitTheGeofenceRadiusIsMeasuredIn": "La unidad de distancia en la que se mide el radio de la geocerca.",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "Información adicional para ayudar a completar el campo de tipo de unidad. Ej: El tipo de unidad debe ser solo números",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "Cuando el limitador alcanza el 100%, esta función permite que solo los usuarios del almacén anulen y creen o aprueben citas y unidades",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Establece el valor numérico máximo que se puede ingresar para el campo de Unidades de Manejo en una cita",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Establece el valor numérico mínimo que se puede ingresar para el campo de Unidades de Manejo en una cita",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "El atributo del activo que el sistema utilizará para validar el formulario de salida",
    "enforceBolSigningOnCheckOutForm": "Requerir la firma del BOL en el formulario de salida",
    "driverMustPrintTheBolToCompleteTheCheckoutWithAPhysicalSignature": "El conductor debe imprimir el BOL para completar la salida con una firma física.",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "Si el BOL no está disponible, el transportista no podrá firmarlo, por lo que la salida se bloqueará. Aquí puedes establecer instrucciones personalizadas que el conductor verá en caso de que esto suceda.",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "Mostrar el componente Persona en el flujo de check-in para verificación de identidad",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "Requerir validación Persona exitosa antes de que el conductor pueda completar el check-in",
    "personaTemplateUsedForCheckInIdentityVerification": "Plantilla Persona usada para verificación de identidad en el check-in",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "Los suscriptores del almacén reciben notificaciones por correo electrónico cuando ocurre un check-in no planificado",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "Este mensaje reemplaza el texto de confirmación de check-in predeterminado que se envía al conductor por SMS. Déjalo en blanco para usar el mensaje predeterminado.",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "Envía el Mapa del Patio como un mensaje de imagen independiente justo después del SMS de check-in. Requiere que se haya subido un Mapa del Patio para este almacén.",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "Los registros de validación de ID almacenados se eliminan permanentemente una vez que pasa el período de retención",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "Número de días que se conserva una validación de ID almacenada antes de eliminarla",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Determina cómo se mostrarán las fechas a los usuarios de esta empresa en todas las experiencias dirigidas a la empresa.",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Determina cómo se mostrará la hora a los usuarios de esta empresa en todas las experiencias dirigidas a la empresa."
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "Número de referencia asociado con la cita",
    "insertMessageHere": "Insertar mensaje aquí"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "En la hora exacta (:00)",
      "topAndBottomOfTheHour00And30": "A la hora y media hora (:00 y :30)",
      "everyTwentyMinutes0020And40": "Cada veinte minutos (:00, :20 y :40)",
      "everyQuarterOfTheHour001530And45": "Cada cuarto de hora (:00, :15, :30 y :45)",
      "customStartTimes": "Horarios personalizados"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 minutos",
      "30Minutes": "30 minutos",
      "60Minutes": "60 minutos",
      "90Minutes": "90 minutos"
    },
    "observationMatchAttribute": {
      "licensePlate": "Placa del vehículo",
      "dotNumber": "Número DOT",
      "any": "Cualquiera",
      "cascade": "Cascada"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "Alfanumérico",
      "numeric": "Numérico"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "Programado",
      "requested": "Solicitado"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "En progreso",
      "completed": "Completado"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "No, no incluir el campo de número de referencia",
      "yesIncludeTheReferenceNumberField": "Sí, incluir el campo de número de referencia"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "No, no ocultar la duración del tipo de carga",
      "yesHideTheLoadTypeDuration": "Sí, ocultar la duración del tipo de carga"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "No, desactivar notificaciones de citas",
      "yesEnableAppointmentNotifications": "Sí, activar notificaciones de citas"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "No, no permitir selección de andén",
      "yesAllowTheDockSelection": "Sí, permitir selección de andén"
    },
    "displayTimeIn": {
      "regularTime12Hour": "Hora regular (12 horas)",
      "militaryTime24Hour": "Hora militar (24 horas)"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "Permitir reprogramación en el portal de citas",
      "preventReschedulingInTheSchedulingPortal": "Impedir reprogramación en el portal de citas"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "Revertir a Solicitado al reprogramar por el transportista",
      "keepStatusUnchangedOnCarrierReschedule": "Mantener el estado sin cambios al reprogramar por el transportista"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "No, no hacer obligatorio el número de referencia",
      "yesMakeReferenceNumberARequiredField": "Sí, hacer obligatorio el número de referencia"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "No, no requerir números de referencia únicos",
      "yesRequireUniqueReferenceNumbers": "Sí, requerir números de referencia únicos"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "No, no hacer obligatorias las Unidades de Manejo",
      "yesMakeHandlingUnitsARequiredField": "Sí, hacer obligatorias las Unidades de Manejo"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "No, no incluir el campo de Unidades de Manejo",
      "yesIncludeTheHandlingUnitsField": "Sí, incluir el campo de Unidades de Manejo"
    },
    "checkOutIdentifier": {
      "licensePlate": "Placa del vehículo",
      "phoneNumber": "Número de teléfono",
      "any": "Cualquiera"
    },
    "geofenceRadiusUnit": {
      "miles": "Millas",
      "kilometers": "Kilómetros"
    },
    "enableCheckInIdValidationPersona": {
      "no": "No",
      "yes": "Sí"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "No",
      "yes": "Sí"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "Licencia de conducir - Frente - 1 reintento",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "Licencia de conducir - Frente, código de barras, rostro, solo EE. UU., 1 reintento"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "No",
      "yes": "Sí"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/AAAA",
      "ddMmYyyy": "DD/MM/AAAA",
      "yyyyMmDd": "AAAA-MM-DD",
      "tueMmDdYyyy": "Mar, MM/DD/AAAA",
      "tueDdMmYyyy": "Mar, DD/MM/AAAA",
      "tueYyyyMmDd": "Mar, AAAA-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 horas (p. ej., 7:00 AM)",
      "24HourEG0700": "24 horas (p. ej., 07:00)"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "Ej. 7:00 AM / 7:00 PM",
      "eG07001900": "Ej. 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "Nota:",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "Si se deja en blanco, se aplicará el nombre predeterminado",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "Si se deja en blanco, se aplicará el texto de ayuda predeterminado",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "Habilitar esta opción no afecta las notificaciones que ya estén desactivadas individualmente en el nivel de la cita.",
    "ifLeftEmptyNoNotificationsWillBeSent": "Si se deja en blanco, no se enviarán notificaciones",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "El número de referencia asignado a citas canceladas o sin asistencia puede reutilizarse en nuevas citas",
    "ifEmptyTheDefaultNameWillBeApplied": "Si está vacío, se aplicará el nombre predeterminado"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "Conductores",
    "checkInSms": "SMS de check-in",
    "dataRetention": "Retención de datos"
  }
}
